import { TAG_DICT } from 'src/assets/dicom-tag-dict'
import { UIDS_DICT } from 'src/assets/dicom-uids-dict'

export function findElement(dataSet: any, element: any, out: any) {
  function getTag(tag: any) {
    var group = tag.substring(1, 5);
    var element = tag.substring(5, 9);
    var tagIndex = ('(' + group + ',' + element + ')').toUpperCase();
    var attr = TAG_DICT[tagIndex];
    return attr;
  }

  try {
    var keys: any[] = [];
    for (let propertyName in dataSet.elements) {
      keys.push(propertyName);
    }
    keys.sort();

    for (var k = 0; k < keys.length; k++) {
      var propertyName = keys[k];

      var actualElement = dataSet.elements[propertyName];

      if (propertyName == element) {
        let vr = getTag(actualElement.tag).vr;
        if (vr === 'US') {
          out.push(dataSet.uint16(element));
        }
        else if (vr === 'SS') {
          out.push(dataSet.int16(element));
        }
        else if (vr === 'UL') {
          out.push(dataSet.uint32(element));
        }
        else if (vr === 'SL') {
          out.push(dataSet.int32(element));
        }
        else if (vr == 'FD') {
          out.push(dataSet.double(element));
        }
        else if (vr == 'FL') {
          out.push(dataSet.float(element));
        }
        else {
          out.push(dataSet.string(element));
        }
      }


      if (actualElement.items) {
        actualElement.items.forEach((item: any) => {
          findElement(item.dataSet, element, out)
        })
      }
    }
  } catch (err) {
    var ex = {
      exception: err
    }
    throw ex;
  }
}

export function findFirstElement(dataSet: any, element: any) {
  function getTag(tag: string) {
    let group = tag.substring(1, 5);
    const element = tag.substring(5, 9);
    let tagIndex = ('(' + group + ',' + element + ')').toUpperCase();
    let attr = TAG_DICT[tagIndex];
    if (!attr) {
      group = tag.substring(1, 3) + 'xx';
      tagIndex = ('(' + group + ',' + element + ')');
      attr = TAG_DICT[tagIndex];
    }
    return attr;
  }

  try {
    var keys: any[] = [];
    for (let propertyName in dataSet.elements) {
      keys.push(propertyName);
    }
    keys.sort();

    for (var k = 0; k < keys.length; k++) {
      var propertyName = keys[k];

      var actualElement = dataSet.elements[propertyName];

      if (propertyName == element) {
        const tag = getTag(actualElement.tag);

        if (!tag) {
          return;
        }
        const vr = tag.vr;
        if (vr === 'US') {
          return (dataSet.uint16(element));
        }
        else if (vr === 'SS') {
          if (tag.vm > 1) {
            return new Uint16Array(dataSet.byteArray.buffer, actualElement.dataOffset, actualElement.length);
          }
          return (dataSet.int16(element));
        }
        else if (vr === 'UL') {
          return (dataSet.uint32(element));
        }
        else if (vr === 'SL') {
          return (dataSet.int32(element));
        }
        else if (vr == 'FD') {
          return (dataSet.double(element));
        }
        else if (vr == 'FL') {
          return (dataSet.float(element));
        }
        else if (vr == 'OB|OW') {
          let data: any[] = [];
          for (let i = 0; i < actualElement.length; i++) {
            for (let j = 0; j < 8; j++) {
              const byte_as_int = dataSet.byteArray[actualElement.dataOffset + i];
              // tslint:disable-next-line: no-bitwise
              data[i * 8 + j] = (byte_as_int >> j) & 0b1;
            }
          }
          return data;
        }
        else {
          return (dataSet.string(element));
        }
      }


      if (actualElement.items) {
        actualElement.items.forEach((item: any) => {
          return findFirstElement(item.dataSet, element);
        })
      }
    }
  } catch (err) {
    var ex = {
      exception: err
    }
    throw ex;
  }
}

export function formatTag(tag: string) {
  let formattedTag;

  if (tag[0] == '(') {

    let st = tag.split(',');
    let group = st[0].substr(1, 4);
    let element = st[1].substr(0, 4);
    formattedTag = `x${group}${element}`;

  } else if (tag[0] == 'x') {

    let group = tag.substring(1, 5);
    const element = tag.substring(5, 9);
    let tagIndex = ('(' + group + ',' + element + ')').toUpperCase();
    let attr = TAG_DICT[tagIndex];
    if (!attr) {
      group = tag.substring(1, 3) + 'xx';
      tagIndex = ('(' + group + ',' + element + ')');
      formattedTag = TAG_DICT[tagIndex];
    }
    return attr.tag;

  }
  return formattedTag;
}